import { object, string } from 'yup';

import { ProviderName } from 'v2/constants';
import { SlotModel } from 'v2/types/SlotModel';

export type SlotForm = Omit<SlotModel, 'id'>;

export const initialValues: SlotForm = {
  identifier: '',
  title: '',
  providerName: ProviderName.BGAMING,
  isActive: true,
  order: 1,
  marks: [],
  iconId: '',
  mobileIconId: null,
};

export const validationSchema = object().shape({
  iconId: string().trim().required(),
});
